export const navigation = [
  {
    text: 'Dashboard',
    path: '/home',
    icon: 'home',
    data: { roles: ['Editor', 'VehicleStaff'] }
  },
  {
    text: 'Vize İşlemleri',
    icon: 'ordersbox',
    data: { roles: ['Editor'] },
    expanded: true,
    items: [
      {
        text: 'Vize Başvuru İşlemleri',
        path: '/visa-application-list',

      },
      {
        text: 'Vize Tanımları',
        path: '/visa-definition',

      }
    ]
  },
  {
    text: 'Fiyatlandırma',
    icon: 'money',
    data: { roles: ['Editor'] },
    expanded: true,
    items: [
      {
        text: 'Fiyat/İndirim Tanımları',
        path: '/discount-definition',

      },
      // {
      //   text: 'İndirim Oranları',
      //   path: '/percentage',

      // }
    ]
  },
  {
    text: 'İçerik Yönetimi',
    icon: 'bulletlist',
    data: { roles: ['Editor'] },
    expanded: true,
    items: [
      {
        text: 'Hakkımızda',
        path: '/about',

      },
      {
        text: 'Sözleşmeler',
        path: '/policies-kvkk',

      },
      {
        text: 'SSS',
        path: '/frequently-asked-questions',

      },
      {
        text: 'Blog(Yazılar)',
        path: '/blog',

      },
      {
        text: 'Slider Ayarları',
        path: '/slider',

      }
    ]
  },

  {
    text: 'Kullanıcı Yönetimi',
    path: '/profile',
    icon: 'user'
  },

  {
    text: 'Tanımlamalar',
    path: '/defination',
    icon: 'description'
  },
  {
    text: 'Log Kayıtları',
    path: '/eventlog',
    icon: 'textdocument'
  }
];
